import { PLURAL_SEGMENT } from '@/components/ParticipantTabs/ParticipantTabs.constants';
import { ParticipantTabState } from '@/components/ParticipantTabs/ParticipantTabs.types';
import { ParticipantEnum, ROUTES } from '@/constants/common';

export const isSearchInSection = (
  pathname: string,
  participant: ParticipantEnum
): boolean => {
  const participantSegment = PLURAL_SEGMENT[participant];
  const participantSearchBase = `${ROUTES.SEARCH}/${participantSegment}`;
  return (
    pathname === participantSearchBase ||
    pathname.startsWith(`${participantSearchBase}/`)
  );
};

export const getTabState = ({
  pathname,
  isDetailsPage,
  participant
}: ParticipantTabState): { isSelected: boolean; disabled: boolean } => {
  const participantSegment = PLURAL_SEGMENT[participant];

  const parts = (pathname || '').split('/').filter(Boolean);
  const primaryPart = parts[0] || '';

  const isValidLocale =
    primaryPart.length === 2 || /^[a-z]{2}-[A-Za-z]{2,}$/.test(primaryPart);
  const selectedSection = parts[isValidLocale ? 1 : 0] || '';

  const selectedBySearch = isSearchInSection(pathname, participant);

  const selectedByLanding =
    (participant === ParticipantEnum.VACANCY && selectedSection === '') ||
    selectedSection === participantSegment;

  const disabled = selectedBySearch;
  const isSelected = !isDetailsPage && (selectedBySearch || selectedByLanding);

  return { isSelected, disabled };
};
